export default "__VITE_ASSET__DrZPtv2u__"